"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointTaskRequest = void 0;
var MyPointTaskRequest = /** @class */ (function () {
    function MyPointTaskRequest() {
    }
    return MyPointTaskRequest;
}());
exports.MyPointTaskRequest = MyPointTaskRequest;
;
//# sourceMappingURL=myPointTask.request.js.map